export { default } from "./activity.web";
